"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepaidDateFilterToJSON = exports.PrepaidDateFilterFromJSONTyped = exports.PrepaidDateFilterFromJSON = exports.instanceOfPrepaidDateFilter = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the PrepaidDateFilter interface.
 */
function instanceOfPrepaidDateFilter(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPrepaidDateFilter = instanceOfPrepaidDateFilter;
function PrepaidDateFilterFromJSON(json) {
    return PrepaidDateFilterFromJSONTyped(json, false);
}
exports.PrepaidDateFilterFromJSON = PrepaidDateFilterFromJSON;
function PrepaidDateFilterFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'startDate': !(0, runtime_1.exists)(json, 'start_date') ? undefined : (new Date(json['start_date'])),
        'endDate': !(0, runtime_1.exists)(json, 'end_date') ? undefined : (new Date(json['end_date'])),
    };
}
exports.PrepaidDateFilterFromJSONTyped = PrepaidDateFilterFromJSONTyped;
function PrepaidDateFilterToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'start_date': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'end_date': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
    };
}
exports.PrepaidDateFilterToJSON = PrepaidDateFilterToJSON;
